import { render, staticRenderFns } from "./localbranch-style-1.vue?vue&type=template&id=396e6195&"
import script from "./localbranch-style-1.vue?vue&type=script&lang=js&"
export * from "./localbranch-style-1.vue?vue&type=script&lang=js&"
import style0 from "./localbranch-style-1.vue?vue&type=style&index=0&id=396e6195&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports